module.exports = __webpack_public_path__ + "img/polar.4bb1b03.webp";